import axiosInstance from '../api/axios';

export const previewAutoSchedule = async ({ reportTypes, batches, mode, durationMinutes }) => {
    try {
        // Spring's @RequestParam List<String> expects repeated keys (reportTypes=A&reportTypes=B),
        // not the bracket notation (reportTypes[]=A) axios's default array serializer produces.
        // Passing a URLSearchParams instance makes axios use it as-is instead of re-serializing.
        const params = new URLSearchParams();
        reportTypes.forEach((value) => params.append('reportTypes', value));
        batches.forEach((value) => params.append('batches', value));
        params.append('mode', mode);
        if (durationMinutes) params.append('durationMinutes', durationMinutes);

        const response = await axiosInstance.get('/viva/auto-schedule-preview', { params });
        return response.data;
    } catch (error) {
        console.error('Error generating viva auto-schedule preview:', error);
        throw error;
    }
};

export const getAvailableSlots = async ({ examinerId1, examinerId2, reviewerId1, reviewerId2, durationMinutes }) => {
    try {
        const response = await axiosInstance.get('/viva/available-slots', {
            params: { examinerId1, examinerId2, reviewerId1, reviewerId2, durationMinutes }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching available viva slots:', error);
        throw error;
    }
};

export const savePreSchedule = async (payload) => {
    try {
        const response = await axiosInstance.put('/viva/pre-schedule', payload);
        return response.data;
    } catch (error) {
        console.error('Error saving advance viva schedule:', error);
        throw error;
    }
};

export const assignToReports = async (announcementIds) => {
    try {
        const response = await axiosInstance.post('/viva/assign-to-reports', { announcementIds });
        return response.data;
    } catch (error) {
        console.error('Error assigning viva schedule to reports:', error);
        throw error;
    }
};

export const getAssignToReportsPreview = async (reportTypes, batches) => {
    try {
        const params = new URLSearchParams();
        reportTypes.forEach((value) => params.append('reportTypes', value));
        batches.forEach((value) => params.append('batches', value));
        const response = await axiosInstance.get('/viva/assign-to-reports-preview', { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching assign-to-reports preview:', error);
        throw error;
    }
};

export const assignSingleToReport = async (thesisStatusId) => {
    try {
        const response = await axiosInstance.post('/viva/assign-to-report', { thesisStatusId });
        return response.data;
    } catch (error) {
        console.error('Error assigning viva schedule for this student:', error);
        throw error;
    }
};

export const getPairHistory = async () => {
    try {
        const response = await axiosInstance.get('/viva/pair-history');
        return response.data;
    } catch (error) {
        console.error('Error fetching examiner-reviewer pair history:', error);
        throw error;
    }
};
